// @givmo/org-console — the words the access editor says when a Global Admin is made a regular admin
// (OM-57 web).
//
// THE WORDS' STANDING. Jonathan approved the demotion screen as drawn, with every drafted word on it
// (D-CPO-67, 2026-10-23 21:44 PDT: "the demotion screen and External label screens look good"; the
// frames and their README are in the plan's `scratchpad/2026-10-23-0638-om57-web-mockup-frames/`).
// They are byte-identical here, and `copy-law.test.ts` pins each one: changing a word changes a
// ruling. Kept as it was and not here: "Something went wrong. Please try again.", the editor's one
// generic failure line. Not taken: the reason beside Save (frame F2alt).
//
// THE CLASS ENTERS AS DATA (R5): the host's noun and its app names come from its vocab.

import { GLOBAL_ADMIN_LABEL } from './org-tiers';

export const DEMOTION_COPY = {
  /** Above the apps while Global Admin is off on someone who held it (F2–F4): why Save is off. */
  chooseApps: (self: boolean): string =>
    self
      ? 'Choose the apps you’ll have, and a level for each. Turn on at least one to save.'
      : 'Choose the apps they’ll have, and a level for each. Turn on at least one to save.',
  /** Under the switch while a person turns their own off and another Global Admin may remain (F5b). */
  selfWarning: (orgNoun: string): string =>
    `This is you. Without ${GLOBAL_ADMIN_LABEL} you can’t manage this ${orgNoun}’s team or turn its apps on and off. You’ll keep only the apps you turn on below.`,
  /**
   * The last Global Admin: in the apps' place when the roster the page has loaded is whole and holds
   * no one else at that tier (F5a), and as the server's backstop after a save (F5b).
   */
  onlyGlobalAdmin: `You’re the only ${GLOBAL_ADMIN_LABEL}. Make someone else a ${GLOBAL_ADMIN_LABEL} first, then come back.`,
  /** The 409 `ROLE_CHANGE_NOT_GLOBAL_ADMIN` (F4a): someone else made them a regular admin first. */
  changedElsewhere: (who: string): string =>
    `Someone else changed ${who}’s access while this was open, so nothing was saved. Cancel and reopen to see their access now.`,
  /**
   * The 422 `ROLE_CHANGE_MODULE_UNAVAILABLE` (F4b): the app left the organization's list. NOT "off":
   * an app switched off stays on the list ("Off for the …"); this one left it. `app` is `null` when
   * the server names none.
   */
  appWithdrawn: (app: string | null, orgNoun: string): string =>
    `Givmo took ${app ?? 'one of these apps'} off your ${orgNoun}’s list of apps while this was open, so nothing was saved. Cancel and reopen to choose from the current list.`,
  /** The 422 `ROLE_CHANGE_CHOICE_REQUIRED` (F4c), a choice these controls never send. */
  choiceRequired: `Turn on at least one app, or turn ${GLOBAL_ADMIN_LABEL} back on. Nothing was saved.`,
} as const;
